import React from "react";
import { Segment, Header, Icon } from "semantic-ui-react";
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from "recharts";
import "./AttendanceSummary.scss";

export function AttendanceSummary(props) {
  const { attendance } = props;

  const attendancePieData = attendance?.summary
    ? [
        {
          name: "Faltas",
          value: attendance.summary.absences || 0,
          fill: "#ef4444",
        },
        {
          name: "Tardanzas",
          value: attendance.summary.tardiness || 0,
          fill: "#f59e0b",
        },
        {
          name: "Justificadas",
          value: attendance.summary.justified || 0,
          fill: "#3b82f6",
        },
        {
          name: "Presentes",
          value: attendance.summary.presentDays || 0,
          fill: "#10b981",
        },
      ].filter((item) => item.value > 0)
    : [];

  return (
    <Segment className="dashboard-segment">
      <Header as="h3" dividing>
        <Icon name="chart pie" />
        Resumen de Asistencia
      </Header>
      <div className="attendance-summary">
        <div className="attendance-item absent">
          <span className="value">{attendance?.summary?.absences || 0}</span>
          <span className="label">Faltas</span>
        </div>
        <div className="attendance-item late">
          <span className="value">{attendance?.summary?.tardiness || 0}</span>
          <span className="label">Tardanzas</span>
        </div>
        <div className="attendance-item justified">
          <span className="value">{attendance?.summary?.justified || 0}</span>
          <span className="label">Justificadas</span>
        </div>
        <div className="attendance-item present">
          <span className="value">{attendance?.summary?.presentDays || 0}</span>
          <span className="label">Presentes</span>
        </div>
      </div>
      {attendancePieData.length > 0 && (
        <div style={{ width: "100%", height: 180, marginTop: "1rem" }}>
          <ResponsiveContainer>
            <PieChart>
              <Pie
                data={attendancePieData}
                cx="50%"
                cy="50%"
                innerRadius={40}
                outerRadius={70}
                paddingAngle={3}
                dataKey="value"
              >
                {attendancePieData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.fill} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>
      )}
    </Segment>
  );
}
